import { ISwapQualityIssue } from '@nkr/models/index';
import { Panel } from 'react-bootstrap'

interface IProps {
    data: ISwapQualityIssue
}

const DonorInfo = (props: IProps) => {
    let kidneyArrivalDateTimeActual = props.data != null ? props.data.kidneyArrivalDateTimeActual : '';
    let centerAlias = props.data != null ? props.data.donorCenter : '';
    let rdnCenter = props.data != null ? props.data.rdnCenter : null;
    let alias = props.data != null ? props.data.donorAlias : '';
    let age = props.data != null ? props.data.donorAge : '';
    let fullBloodType = props.data != null ? props.data.donorFullBloodType : '';
    let donorSurgeonName = props.data != null ? props.data.donorSurgeonName : '';

    return (
        <Panel bsStyle='success'>
            <Panel.Heading>Donor Info</Panel.Heading>
            <Panel.Body>
                <div className='row'>
                    <div className='col-lg-6'><strong>Surgery Date</strong></div>
                    <div className='col-lg-6'>
                        {kidneyArrivalDateTimeActual != '' ? kidneyArrivalDateTimeActual : '- not specified -'}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-lg-6'><strong>Transplant Center</strong></div>
                    <div className='col-lg-6'>
                        {rdnCenter != '' ?
                            <>{centerAlias} (<span style={{ color: 'red' }}>{rdnCenter}</span>)</>

                            :
                            <>{centerAlias}</>
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col-lg-6'><strong>Alias</strong></div>
                    <div className='col-lg-6'>{alias}</div>
                </div>

                <div className='row'>
                    <div className='col-lg-6'><strong>Age</strong></div>
                    <div className='col-lg-6'>{age}</div>
                </div>

                <div className='row'>
                    <div className='col-lg-6'><strong>Blood Type</strong></div>
                    <div className='col-lg-6'>{fullBloodType}</div>
                </div>

                <div className='row'>
                    <div className='col-lg-6'><strong>Surgeon</strong></div>
                    <div className='col-lg-6'>
                        {donorSurgeonName != null ? donorSurgeonName : '- not specified -'}
                    </div>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default DonorInfo;